import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import style from './NonLogged.module.scss';
import { useDebounce } from '../../hooks';
import { GetFaqSearch, handleImpressionsTrack } from '../../api';
import { clickTracker, getProjectId } from '../../lib/common';
import { useAuth } from '../../contexts/auth';

const DynamicSearchBar = ({ handleOptionClick, contractType, ecsFlag, jdrrBannerFlag, page }) => {
  const [searchText, setSearchText] = useState('');
  const [searchResults, setSearchResults] = useState({});
  const debouncedSearchText = useDebounce(searchText, 500);
  const [searchDisplay, setSearchDisplay] = useState(false);
  const [authState] = useAuth();
  const searchRef = useRef();
  const hasTracked = useRef(false);
  const projectId = getProjectId();

  const handleSearchInput = async (text) => {
    let searchType = '';
    if (authState?.sidResponse) {
      searchType =
        contractType === 'paid' ? 'paid_dynamicsearch' : contractType === 'free' ? 'Nonpaid_dynamicsearch' : null;
    } else {
      searchType = 'Nonloggedin_dynamicsearch';
    }
    if (!hasTracked.current && text.length > 0) {
      await clickTracker('search', searchType);
      hasTracked.current = true;
    }
    setSearchText(text);
  };

  useEffect(() => {
    const handleGetFaqSearch = async () => {
      try {
        if (debouncedSearchText !== '') {
          const params = {
            type: authState?.sidResponse || page === 'genio' ? contractType : 'nonlogin',
            text: debouncedSearchText,
            source: page,
          };
          if (page === 'csportal') {
            params.ecsFlag = ecsFlag;
            params.jdrrBannerFlag = jdrrBannerFlag;
          }
          const res = await GetFaqSearch(params);
          if (res.errorCode === 1) {
            console.log('error');
          } else if (res.message?.result) {
            setSearchResults({ ...res.message?.result });
            setSearchDisplay(true);
          }
        } else {
          setSearchResults({});
          setSearchDisplay(false);
        }
      } catch (err) {
        console.error('Error: ', err);
      }
    };
    handleGetFaqSearch();
  }, [debouncedSearchText]);

  useEffect(() => {
    const handleDocClickOutside = (event) => {
      if (searchRef?.current && !searchRef?.current?.contains(event.target)) {
        setSearchDisplay(false);
      }
    };
    document.addEventListener('mousedown', handleDocClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleDocClickOutside);
    };
  }, [searchRef]);

  const handleClickFaq = async (faqDetails) => {
    let resultType = '';
    if (authState?.sid) {
      resultType =
        contractType === 'paid' ? 'paid_dynamicsearch' : contractType === 'free' ? 'Nonpaid_dynamicsearch' : null;
    } else {
      resultType = 'Nonloggedin_dynamicsearch';
    }
    await clickTracker('searchresult', resultType);
    const option = {
      title: faqDetails?.faqType?.replace('/', ' '),
      key: faqDetails?.faqType,
      icon: 'hmp_editbusiness',
      type: 'faq',
    };
    await handleOptionClick(option, faqDetails?.id);
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = 'searchbar_result';
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = 'searchbar';
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
  };

  return (
    <div className={`${style.SearchBarMargin}`}>
      <div className={`${style.SeachBox} p-25`}>
        <div className={`${style.SeachGroup} mt-12`}>
          <div className={`${style.SeachIcon} csicon`} />
          <input
            className={`${style.SeachInput} font12 fw400 color111`}
            onChange={(e) => {
              handleSearchInput(e.target.value);
            }}
            onClick={async () => {
              setSearchDisplay(!searchDisplay);
              if (projectId === 'csportal' && !searchDisplay) {
                const liVal = 'click';
                const liTrd = 'click_searchbar';
                const faqTypeVal = '';
                const othersData = [];
                const llTrd = 'cshmpg';
                await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
              }
            }}
            type="text"
            placeholder="Questions? we’ve got answers!"
            value={searchText}
          />
          {searchText !== '' && (
            <div
              aria-label="dynamic_search_input"
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              className={`${style.SeachClear} csicon`}
              onClick={() => handleSearchInput('')}
            />
          )}
          {Object.keys(searchResults)?.length > 0 ? (
            <div className={`${style.SeachDropDown}`} ref={searchRef}>
              {Object.keys(searchResults).map((topic, i) => (
                <div
                  className={`${style.SeachFaq}`}
                  key={`${i}-${topic.id}`}
                  style={{ display: searchDisplay ? 'block' : 'none' }}
                >
                  <div className={`${style.SeachFaqCategory} font12 fw500 color777`}>
                    {topic?.includes('_') ? topic?.split('_')[0] : topic}
                  </div>
                  {searchResults[topic].map((questions, j) => (
                    <div
                      aria-label="dynamic_faq_click"
                      tabIndex={0}
                      role="button"
                      onKeyDown={() => {}}
                      className={`${style.SeachFaqBox} ${style.Active}`}
                      onClick={() => handleClickFaq(questions)}
                      key={`${j}-${topic.id}`}
                    >
                      <div className={`${style.SeachFaqQuestion}`} id={`${j}-${topic.id}`}>
                        <div className={`${style.SeachFaqDot}`} />
                        <div className={`${style.SeachFaqTitle} font13 fw500 color111`}>
                          {questions?.question || ''}
                        </div>
                        <div className={`${style.SeachFaqIcon} csicon`} />
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ) : (
            searchDisplay &&
            debouncedSearchText !== '' && (
              <div className={`${style.SeachDropDown}`} ref={searchRef}>
                <div className={`${style.SearchNoData} font14 fw500`}>Keep trying to search more..</div>
              </div>
            )
          )}
        </div>
      </div>

      {/* <ContractItem /> */}
    </div>
  );
};
export default DynamicSearchBar;

DynamicSearchBar.propTypes = {
  handleOptionClick: PropTypes.func,
  contractType: PropTypes.string,
  ecsFlag: PropTypes.bool,
  jdrrBannerFlag: PropTypes.bool,
  page: PropTypes.string,
};
